import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import UserDetails from "../components/user-profile-lite/UserDetails";
import UserAccountDetails from "../components/user-profile-lite/UserAccountDetails";
import QSortStart from "../components/qsortsettings/gSortStart";


import desktopImage from '../assets/images/background-blobs.png';
import mobileImage from '../assets/images/background-blobs.png';
import InstructionDefault from "../components/instruction/instructionDefault";


const imageUrl = window.innerWidth >= 650 ? desktopImage : mobileImage;
const qsortStart = (props) => (
  <Container fluid className="main-content-container px-4 modal-background"  style={{backgroundImage: `url(${imageUrl})` }}>
      {/* 
    <Row noGutters className="page-header py-4">
      <PageTitle title="Instellingen" subtitle="Q-sort" md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    */}





    <QSortStart qsortdata={props.location.state}/>
    
  </Container>
);

export default qsortStart;
